/**
 * Theme Registry - Domain to theme configuration mapping
 *
 * Each theme defines:
 * - name: Theme identifier
 * - title: Document title (browser tab)
 * - favicon: Favicon image path (falls back to logo if omitted)
 * - logo: Logo image path
 * - gameCategoryImages: { newGames, hotGames, popularGames } images for GameMenu category cards
 * - centerLottie: { src, size, autoplay, loop } config for the bottom-nav center button animation
 * - primary: Primary color (main action buttons - login, register, submit)
 * - primaryLight: Primary gradient end color
 * - secondary: Secondary color (accents, highlights, balance boxes)
 * - secondaryLight: Secondary gradient end color
 * - bodyBackground: { type: 'image' | 'color', value: path or hex }
 */

import { cdnImage } from '@/utils/cdn'

const themes = {
  'kaiju168.com': {
    name: 'kaiju',
    title:
      'KAIJU168 - No.1 Website in Thailand ฝาก-ถอนอัตโนมัติ บริการ 24 ชั่วโมง',
    // eslint-disable-next-line global-require
    favicon: require('@/assets/images/logo/kaiju-2.png'),
    // eslint-disable-next-line global-require
    logo: require('@/assets/images/logo/kaiju-2.png'),
    gameCategoryImages: {
      // eslint-disable-next-line global-require
      newGames: require('@/assets/images/c1.jpg'),
      // eslint-disable-next-line global-require
      hotGames: require('@/assets/images/c2.jpg'),
      // eslint-disable-next-line global-require
      popularGames: require('@/assets/images/c3.jpg')
    },
    centerLottie: {
      src: 'assets/lottie/coin.json',
      size: 160,
      autoplay: true,
      loop: true
    },
    primary: '#B13BFF', // Purple - main action buttons
    primaryLight: '#c96bff',
    secondary: '#d4af37', // Gold - accents, highlights
    secondaryLight: '#f5d675',
    headerBg: 'linear-gradient(180deg, #030015 0%, #060027 50%, #090040 100%)',
    navBg: 'linear-gradient(180deg, #1a1a2e 0%, #0d0816 50%, #0a0a0a 100%)',
    cardBg: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)',
    modalBg: 'linear-gradient(180deg, #030015 0%, #060027 50%, #090040 100%)',
    sidebarBg: 'linear-gradient(180deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%)',
    inputBg: '#283046',
    inputBorder: '#404656',
    bodyBackground: {
      type: 'image',
      value: cdnImage('kaiju/bg.jpg')
    }
  },

  'baki168.games': {
    name: 'baki',
    title:
      'BAKI168 - ออนไลน์เกมส์ ครบ จบ ในที่เดียว เหนือขั้นอีกระดับของการบริการ',
    // eslint-disable-next-line global-require
    favicon: require('@/assets/images/logo/baki-logo.png'),
    // eslint-disable-next-line global-require
    logo: require('@/assets/images/logo/baki-logo.png'),
    gameCategoryImages: {
      // eslint-disable-next-line global-require
      newGames: require('@/assets/images/c4.jpg'),
      // eslint-disable-next-line global-require
      hotGames: require('@/assets/images/c5.jpg'),
      // eslint-disable-next-line global-require
      popularGames: require('@/assets/images/c6.jpg')
    },
    centerLottie: {
      src: 'assets/lottie/Boxing.json',
      size: 80,
      autoplay: false,
      loop: true
    },
    primary: '#DC2626', // Crimson red - main action buttons
    primaryLight: '#EF4444',
    secondary: '#A0522D', // Blood bronze - accents, highlights (warm metal, matches logo reds)
    secondaryLight: '#C96B3E',
    headerBg: 'linear-gradient(180deg, #0a0000 0%, #140505 50%, #1a0808 100%)',
    navBg: 'linear-gradient(180deg, #1a0f0f 0%, #0f0808 50%, #080404 100%)',
    cardBg: 'linear-gradient(135deg, #1a0a0a 0%, #120808 100%)',
    modalBg: 'linear-gradient(180deg, #0a0000 0%, #140505 50%, #1a0808 100%)',
    sidebarBg: 'linear-gradient(180deg, #080404 0%, #1a0a0a 50%, #120808 100%)',
    inputBg: '#1a0a0a',
    inputBorder: '#3a1a1a',
    bodyBackground: {
      type: 'image',
      // eslint-disable-next-line global-require
      value: require('@/assets/images/baki/baki-bg.jpg')
    }
  },

  // Default fallback theme for localhost and unknown domains.
  // Value is the key of another theme entry in this registry.
  default: 'kaiju168.com'
}

export default themes
